import React from 'react';
import { SlPuzzle } from 'react-icons/sl';

export const CLASS_SCHEDULER_TAB = {
    id: 'class-scheduler',
    label: (
        <span className="flex items-center space-x-2">
            <SlPuzzle className="h-4 w-4" />
            <span>Class Scheduler</span>
        </span>
    ),
    path: '/setup/class-scheduler',
    tooltip: 'Create and manage class schedules, assign time slots and resources',
};

export const ASSET_SETUP_TABS = [
    {
        id: 'school-settings',
        label: 'School Settings',
        path: '/setup/school-settings',
        tooltip: 'Configure your institution\'s basic information, contact details, and general settings',
    },
    {
        id: 'year-structure',
        label: 'Periods & Holidays',
        path: '/setup/year-structure',
        tooltip: 'Define academic years, terms, periods, and holiday schedules',
    },
    {
        id: 'teachers',
        label: 'Teachers',
        path: '/setup/teachers',
        tooltip: 'Manage teaching staff, their qualifications, and subject assignments',
    },
    {
        id: 'groups',
        label: 'Groups',
        path: '/setup/groups',
        tooltip: 'Organize students into classes and groups, manage enrollment',
    },
    {
        id: 'rooms',
        label: 'Rooms',
        path: '/setup/rooms',
        tooltip: 'Set up classrooms, labs, and other facilities with capacity and equipment details',
    },
    {
        id: 'subjects',
        label: 'Subjects',
        path: '/setup/subjects',
        tooltip: 'Define courses, curriculum subjects, and academic requirements',
    },
];

export const SETUP_TABS = [CLASS_SCHEDULER_TAB, ...ASSET_SETUP_TABS];

export const DEFAULT_SETUP_TAB_PATH = ASSET_SETUP_TABS.find((tab) => tab.id === 'school-settings').path;
